<template>
    <div>
        <div
            v-if="hasRenewCart"
            class="fs-3 px-3 lh-20 card-ping-upsell primary-05-bkg b-1-primary-10 br mb-4"
        >
            <span>
                {{
                    $l10n.__(
                        'Le renouvellement de votre abonnement est prévu le %(date)s, vous ne pouvez plus modifier votre abonnement seul jusqu’à cette date.',
                        {
                            date: $filters.dateFormatter(renewActiveDate, 'NORMAL_DATE', false),
                        },
                    )
                }}
            </span>
            <span class="semibold">{{ $l10n.__("Besoin d'aide ?") }}</span>
            <el-link
                :disabled="disablePing"
                :underline="false"
                class="semibold"
                type="primary"
                @click="pingToUpsell"
                >{{ $l10n.__('Demander à être recontacté.') }}
            </el-link>
        </div>
        <h2 class="m-0">{{ $l10n.__('Mon abonnement Sellsy') }}</h2>
        <div v-loading="!loaded" class="mt-3">
            <el-tabs v-model="activeTab">
                <el-tab-pane :label="$t.__('common.labels.subscription')" name="overview">
                    <overview
                        :licenseAssignement="licenseAssignement"
                        :isChargebeeProvider="isChargebeeProvider"
                        :chargebeeSubscriptionId="chargebeeSubscriptionId"
                        :chargebeeThirdPartyPayerId="chargebeeThirdPartyPayerId"
                        @go-to-staffs="activeTab = 'staffs'"
                    />
                </el-tab-pane>
                <el-tab-pane
                    :label="$t.__('sellsyaccountmanager.SubscriptionManager.licences_management')"
                    name="staffs"
                >
                    <staffs />
                </el-tab-pane>
                <el-tab-pane
                    v-if="shouldDisplayDocsPane"
                    :label="$t.__('common.labels.invoices_and_credit_notes')"
                    name="documents"
                >
                    <documents :documents="documents" :isChargebeeProvider="isChargebeeProvider" />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import Overview from './SubscriptionManager/Overview.vue';
import Staffs from './SubscriptionManager/Staffs.vue';
import Documents from './SubscriptionManager/Documents.vue';
import { createNamespacedHelpers } from 'vuex';
import LocalStorage from 'Core/commons/LocalStorage';
import subscription from 'api/sellsyaccountmanager/subscription';
import Feature from 'Services/Feature';

const { mapState, mapGetters } = createNamespacedHelpers('subscriptionManager');

export default {
    components: {
        Overview,
        Staffs,
        Documents,
    },
    props: {
        provider: {
            type: String,
            required: false,
            default: 'stripe',
        },
        chargebeeSubscriptionId: {
            type: String,
            required: false,
            default: '',
        },
        chargebeeThirdPartyPayerId: {
            type: String,
            required: false,
            default: '',
        },
        licenseAssignement: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            activeTab: this.licenseAssignement ? 'staffs' : 'overview',
            localstorage: new LocalStorage('sam', 'call-upsell-before-renew'),
            lastPingTime: null,
            documents: [],
        };
    },
    computed: {
        ...mapState(['loaded', 'renewActiveDate']),
        ...mapGetters(['hasRenewCart']),
        disablePing() {
            if (!this.lastPingTime) return false;

            return moment().diff(moment.utc(this.lastPingTime), 'hours', true) <= 2;
        },
        isChargebeeProvider() {
            return this.provider === 'chargebee' && Feature.isEnabled('chargebee');
        },
        shouldDisplayDocsPane() {
            if (this.licenseAssignement) {
                return false;
            }
            return !(this.documents.length === 0 && this.isChargebeeProvider);
        },
    },
    created() {
        this.lastPingTime = this.localstorage.get() ?? null;
        subscription
            .getDocuments()
            .then((documents) => {
                this.documents = documents;
            })
            .catch(() => {
                this.documents = [];
            });
    },
    methods: {
        pingToUpsell() {
            if (this.disablePing) return;

            this.$ajax.post(
                `/rest/prospection/opportunities/recontact/create`,
                {},
                {},
                () => {
                    Push.success(
                        this.$l10n.__(
                            'Votre demande a bien été prise en compte, vous serez recontacté dans la journée.',
                        ),
                    );
                    this.lastPingTime = moment().utc().format();
                    this.localstorage.set(this.lastPingTime);
                },
                () => {
                    Push.error(
                        this.$l10n.__(
                            "Votre demande n'a pas été prise en compte. Veuillez réessayer ultérieurement",
                        ),
                    );
                },
            );
        },
    },
};
</script>

<style>
.el-tabs__item {
    padding: 12px !important;
    padding-bottom: 8px !important;
    padding-top: 0px !important;
}

#tab-overview {
    padding-left: 0px !important;
}

.el-tabs__header {
    margin-bottom: 25px !important;
}

.card-ping-upsell {
    padding-bottom: 6px;
    padding-top: 6px;
}
</style>
